import { Injectable } from '@angular/core';
import { ClinicDepartment } from '../../domain/models/clinic-department.model';
import { DepartmentDto } from '../dtos/department.dto';

@Injectable({ providedIn: 'root' })
export class DepartmentMapper {
  public toClinicDepartment(dto: DepartmentDto): ClinicDepartment {
    return {
      id: dto.Id,
      name: dto.Name,
      timeZone: dto.TimeZone ?? null,
      externalId: dto.ExternalId ?? null,
      isActive: dto.IsActive ?? true,
    };
  }
}
